module.exports = __webpack_public_path__ + "img/give-money-hand_down.9268a4c6.svg";